import { CartActionTypes } from '../actions';
import { BigCommerceSubscriptionSKU } from '../constants/bigcommerce-mappings';

export const cartInitialState = {
  currency: 'gbp',
  items: [],
  killTimer: false,
  open: false,
  preferredCurrency: false,
}; // qty, gift, product

const getExistingItem = (items, itemToCheck) => {
  return items.find(
    (item) =>
      item.product.bigcommerce_id === itemToCheck.product.bigcommerce_id &&
      item.format === itemToCheck.format,
  );
};

const addItem = (items, itemToAdd) => {
  if (getExistingItem(items, itemToAdd)) {
    return items.map((item) => {
      const match =
        item.product.bigcommerce_id === itemToAdd.product.bigcommerce_id &&
        item.format === itemToAdd.format;

      if (match) {
        if (
          item.format === 'digital' ||
          item.product.sku === BigCommerceSubscriptionSKU
        ) {
          return {
            ...item,
            quantity: item.quantity,
          };
        }
        return {
          ...item,
          quantity: item.quantity + 1,
        };
      }
      return item;
    });
  }
  return [...items, { ...itemToAdd, quantity: 1 }];
};
const removeItem = (items, itemToRemove) => {
  const existingItem = getExistingItem(items, itemToRemove);
  if (existingItem && existingItem.quantity === 1) {
    return items.filter(
      (item) =>
        !(
          item.product.bigcommerce_id === itemToRemove.product.bigcommerce_id &&
          item.format === itemToRemove.format
        ),
    );
  }

  return items.map((item) =>
    item.product.bigcommerce_id === itemToRemove.product.bigcommerce_id &&
    item.format === itemToRemove.format
      ? { ...item, quantity: item.quantity - 1 }
      : item,
  );
};

const closeCart = (timer) => {
  if (timer) clearTimeout(timer);

  return false;
};

export const cartReducer = (state, { payload, type }) => {
  switch (type) {
    case CartActionTypes.CLOSE:
      return {
        ...state,
        killTimer: true,
        open: closeCart(payload),
      };
    case CartActionTypes.OPEN:
      return {
        ...state,
        killTimer: payload,
        open: true,
      };
    case CartActionTypes.ADD_ITEM:
      return {
        ...state,
        items: addItem(state.items, payload),
      };
    case CartActionTypes.REMOVE_ITEM:
      return {
        ...state,
        items: removeItem(state.items, payload),
      };
    case CartActionTypes.SET_CURRENCY:
      return {
        ...state,
        currency: payload.currency,
        preferredCurrency: payload.preferredCurrency,
      };
    case CartActionTypes.RESET:
      return {
        ...cartInitialState,
      };
    default:
      return state;
  }
};
